var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7CB6E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96ic8fhufa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.772 24.125c-.051-.04-3.772-2.723-4.793-2.53-.488.086-.767.419-1.326 1.084-.09.108-.306.365-.474.549a8.563 8.563 0 0 1-5.403-5.402c.184-.17.442-.386.552-.479.662-.556.995-.835 1.081-1.323.177-1.013-2.503-4.759-2.53-4.793a1.43 1.43 0 0 0-1.066-.606c-1.087 0-4.188 4.023-4.188 4.7 0 .04.057 4.043 4.992 9.063 5.016 4.93 9.018 4.987 9.057 4.987.678 0 4.701-3.101 4.701-4.188a1.427 1.427 0 0 0-.603-1.062z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "96ic8fhufa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.51ce8ae55341134b74be1c0deb3d1bdb.svg";
export { ForwardRef as ReactComponent };